module.exports = __webpack_public_path__ + "img/Spinner_large.9fd7c553.gif";